Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SocialContentDetailsTimestampView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/details/timestamp']

  initialize: ({@timestamp}) ->
    undefined

  render: ->
    @setElement @template
      timestamp: @timestamp.format 'DD/MM/YYYY HH:mm'
      titleText: @_titleText()
    @

  _titleText: ->
    @timestamp.format 'DD/MM/YYYY HH:mmZ'
